// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UC-3","top":"styles_top__1jLJI"};